import { Component, OnInit } from '@angular/core';

declare var $: any;
import * as _ from 'lodash';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { CommonFunction } from 'src/app/helpers/commonFunction';
import { DefaultmeetingService } from 'src/app/services/defaultmeeting.service';
import { ActivatedRoute, Router } from '@angular/router';
import { AlertComponent } from '../../alert/alert.component';
import { MeetingMasterService } from 'src/app/services/meeting-master.service';
import { LoaderService } from 'src/app/services/loader.service';
@Component({
  selector: 'app-default-meeting-add',
  templateUrl: './default-meeting-add.component.html',
  styleUrls: ['./default-meeting-add.component.css']
})
export class DefaultMeetingAddComponent implements OnInit {
  constructor(
    private meetingService: MeetingMasterService,
    private commonFunction: CommonFunction,
    private activatedRoute: ActivatedRoute,
    private defaultmeetingService: DefaultmeetingService,
    private router:Router,
    private alert:AlertComponent,
    private route: ActivatedRoute,
    private loaderService: LoaderService
  ) { }

  addDefaultMeetingForm: FormGroup;
  meetingTypes: any;
  titleOnAddUpdate:any;
  globalDefaultMeetingId: any;
  disabledOnclick: boolean = false;
  numList: Array<string> = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];
  restrictTabFlag: boolean;
  meetingIds: Array<any> = [];
  meetingTypeExistId:Array<any> = [];
  meetingTypeListNew:Array<any> = [];
  MeetingTypeIDForEdit:any;
  MeetingTypeNameForEdit:any;

  ngOnDestroy(): void {
    // Re-enable loader when navigating away from this component
    this.loaderService.enable();
  }

  ngOnInit() {
    this.loaderService.disable();
    this.meetingTypes = [];

    this.addDefaultMeetingForm = new FormGroup({
      MeetingType: new FormControl('', [Validators.required]),
      EmailID: new FormControl('', []),
      MeetingPlace: new FormControl('', []),
      NoticeSignatoryName: new FormControl('', []),
      ContactNumber: new FormControl('', []),
      NoticeSignatoryDesignation: new FormControl('', []),
      DinNumber: new FormControl('', []),
      // SigningNoticeDate: new FormControl('', []),
      SigningNoticePlace: new FormControl('', [])
    });

    this.meetingService.getMeetingTypeList()
      .subscribe(meetingTypeList => {
        if (meetingTypeList.status == 0) {
          meetingTypeList.meetingTypeList.forEach((mdata) => {
            this.meetingIds.push(mdata._id)
          })
          var meetData={
            meetingIds:this.meetingIds
          }
          this.defaultmeetingService.checkMeetingTypeExist(meetData).subscribe(meetingTypeExist => {
            if(meetingTypeExist.status==0)
            {
              meetingTypeExist.defaultMeetingDataExist.forEach((mExistData) => {
                this.meetingTypeExistId.push(mExistData.MeetingTypeID);
              });
              meetingTypeList.meetingTypeList.forEach((mDataList) => {
                  if($.inArray(mDataList._id, this.meetingTypeExistId) == -1)
                  {
                   this.meetingTypeListNew.push({
                     "_id":mDataList._id,
                     "MeetingType":mDataList.MeetingType
                    })
                  }
              });
              if(this.meetingTypeListNew.length>0)
              {
                this.meetingTypes = this.commonFunction.sortByKey(this.meetingTypeListNew, 'MeetingType');
              }
              // else{
              //   this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');
              // }
            }else{
              this.meetingTypes = this.commonFunction.sortByKey(meetingTypeList.meetingTypeList, 'MeetingType');
            }
          })
         
          this.activatedRoute.params.subscribe(params => {
            if (params['deftMeetingId'] != undefined) {
              // it is edit page
              this.titleOnAddUpdate = 'Update Default Meeting Details';
              this.restrictTabFlag = true;
              this.globalDefaultMeetingId = params['deftMeetingId'];
              this.displayEditDataOfDefaultMeeting(params['deftMeetingId']);
              // var data = {
              //   module: 'Meeting',
              //   ID: params['meetingId'],
              //   CompanyID: JSON.parse(localStorage.getItem("companyDetails")).companyID
              // }
              // this.meetingService.authonticateDataForComapnay(data).subscribe(meetingAccess => {
              //   if (meetingAccess.status == 0) {
              //     this.loadMeetingDetails(params['meetingId']);
              //   } else {
              //     this.authAlert.validateModuleWithPermissions('Meeting', params['meetingId'], meetingAccess.companyID, 'edit')
              //   }
              // })
            }
            else {
              this.titleOnAddUpdate = 'Add Default Meeting Details';
              this.restrictTabFlag = false;
            }
          });
        }
      })

  }
  
  addAndUpdateDefaultMeeting() {
    this.disabledOnclick = true;
    if (this.globalDefaultMeetingId != undefined) {
      this.updateDefaultMeeting(this.globalDefaultMeetingId);
    } else {
      this.addDefaultMeeting();
    }
  }

  addDefaultMeeting()
  {
    if(this.addDefaultMeetingForm.valid)
    {
      let self = this;
      let meetingObject = _.find(this.meetingTypes, function (element) { return element._id == self.addDefaultMeetingForm.controls.MeetingType.value });
      var defaultMeeting = {
        MeetingTypeID: this.addDefaultMeetingForm.controls.MeetingType.value,
        MeetingTypeName: meetingObject.MeetingType,
        MeetingPlace: this.addDefaultMeetingForm.controls.MeetingPlace.value,
        NoticeSignatoryName: this.addDefaultMeetingForm.controls.NoticeSignatoryName.value,
        ContactNumber: this.addDefaultMeetingForm.controls.ContactNumber.value,
        EmailID: this.addDefaultMeetingForm.controls.EmailID.value,
        NoticeSignatoryDesignation: this.addDefaultMeetingForm.controls.NoticeSignatoryDesignation.value,
        DinNumber: this.addDefaultMeetingForm.controls.DinNumber.value,
        // SigningNoticeDate: this.setDate(this.addDefaultMeetingForm.controls.SigningNoticeDate.value),
        SigningNoticePlace: this.addDefaultMeetingForm.controls.SigningNoticePlace.value,
      }
      this.defaultmeetingService.addDefaultMeeting(defaultMeeting)
        .subscribe(meetingData => {
          if (meetingData.status == 0) {
            this.disabledOnclick = false;
            this.alert.successWithOk(meetingData.message, 'defaultMeeting');
          }
      });
    }
  }

  updateDefaultMeeting(DefaultMeetingId)
  {
    if(this.addDefaultMeetingForm.valid)
    {
      var defaultMeetingUpdateData = {
        MeetingPlace: this.addDefaultMeetingForm.controls.MeetingPlace.value,
        NoticeSignatoryName: this.addDefaultMeetingForm.controls.NoticeSignatoryName.value,
        ContactNumber: this.addDefaultMeetingForm.controls.ContactNumber.value,
        EmailID: this.addDefaultMeetingForm.controls.EmailID.value,
        NoticeSignatoryDesignation: this.addDefaultMeetingForm.controls.NoticeSignatoryDesignation.value,
        DinNumber: this.addDefaultMeetingForm.controls.DinNumber.value,
        // SigningNoticeDate: this.setDate(this.addDefaultMeetingForm.controls.SigningNoticeDate.value),
        SigningNoticePlace: this.addDefaultMeetingForm.controls.SigningNoticePlace.value,
      }

      this.defaultmeetingService.updateDefaultMeeting(defaultMeetingUpdateData,DefaultMeetingId)
        .subscribe(updateMeetingData => {
          if (updateMeetingData.status == 0) {
            this.disabledOnclick = false;
            this.alert.successWithOk(updateMeetingData.message, 'defaultMeeting');
          }
      });
    } 
  }

  displayEditDataOfDefaultMeeting(dftMeetId)
  {
    if(dftMeetId!=undefined)
    {
      this.defaultmeetingService.getDefaultMeetingDataById(dftMeetId)
      .subscribe(editData => {
          if(editData.status==0)
          {
            var displayData=editData.defaultMeetingData[0];
            this.addDefaultMeetingForm.controls.MeetingType.setValue(displayData.MeetingTypeID);
            this.MeetingTypeIDForEdit=displayData.MeetingTypeID;
            this.MeetingTypeNameForEdit=displayData.MeetingTypeName;
            this.addDefaultMeetingForm.controls.MeetingType.disable()
            this.addDefaultMeetingForm.controls.MeetingPlace.setValue(displayData.MeetingPlace);
            this.addDefaultMeetingForm.controls.NoticeSignatoryName.setValue(displayData.NoticeSignatoryName);
            this.addDefaultMeetingForm.controls.ContactNumber.setValue(displayData.ContactNumber);
            this.addDefaultMeetingForm.controls.EmailID.setValue(displayData.EmailID);
            this.addDefaultMeetingForm.controls.NoticeSignatoryDesignation.setValue(displayData.NoticeSignatoryDesignation);
            this.addDefaultMeetingForm.controls.DinNumber.setValue(displayData.DinNumber);
            // if (displayData.SigningNoticeDate != null) {
            //   var dt = new Date(this.setFormatDate(displayData.SigningNoticeDate));
            //   this.addDefaultMeetingForm.controls.SigningNoticeDate.setValue({ month: dt.getMonth() + 1, day: dt.getDate(), year: dt.getFullYear() });
            // }
            this.addDefaultMeetingForm.controls.SigningNoticePlace.setValue(displayData.SigningNoticePlace);
          }
      });
    }
  }

  back() {
    this.addDefaultMeetingForm.reset();
    this.router.navigate(
      [{ outlets: { 'structure-outlet': ['defaultMeeting', ]  } }],
      { relativeTo: this.route.parent });
    this.ngOnInit();
  }

  setDate(date) {
    if (date != "" && date != null) {
      return date.month + "-" + date.day + "-" + date.year;
    }
    return null;
  }

  setFormatDate(date) {
    if (date != null) {
      return new Date(date);
    }
    return null;
  }

  DinNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 8 digits
      if ((ev.target.value + ev.key).length > 8) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

  onlyNumber(ev) {
    var keyCode = window.event ? ev.keyCode : ev.which;
    //codes for 0-9
    if ((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106) || (keyCode > 34 && keyCode < 41) || (keyCode == 16) || (keyCode == 46) || (keyCode == 9)) {

      if (((keyCode > 47 && keyCode < 58) || (keyCode > 95 && keyCode < 106)) && this.numList.indexOf(ev.key) == -1) {
        ev.preventDefault();
      }
      //restrict up to 10 digits
      if ((ev.target.value + ev.key).length > 11) {
        ev.preventDefault();
      }
    }
    else {
      if (keyCode != 0 && keyCode != 8 && keyCode != 13 && !ev.ctrlKey) {
        ev.preventDefault();
      }
    }
  }

}
